import NotificationApiClass from 'SharedDir/backend/api/classes/NotificationApiClass';
import { NOTIFICATION_WEBPUSH_PUBLIC_VAPID_KEY } from 'SharedDir/constants/common';

export default class WebPushManager {
  protected subscription: PushSubscription | null = null;

  protected registration: ServiceWorkerRegistration;

  protected notificationApi: NotificationApiClass;

  constructor(
    registration: ServiceWorkerRegistration,
    notificationApi: NotificationApiClass
  ) {
    this.registration = registration;
    this.notificationApi = notificationApi;
  }

  public getSubscription() {
    return this.subscription;
  }

  protected async registerSubscription(subscription: PushSubscription) {
    const subscriptionJson = subscription.toJSON();
    const data = {
      endpoint: subscription.endpoint,
      keysAuth: subscriptionJson.keys?.auth,
      keysP256dh: subscriptionJson.keys?.p256dh,
    };
    await this.notificationApi.sendSubscription(data);
  }

  protected makeNewSubscription() {
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: NOTIFICATION_WEBPUSH_PUBLIC_VAPID_KEY,
    };

    return this.registration.pushManager.subscribe(subscribeOptions);
  }

  async subscribe() {
    if (!(await this.askNotification())) {
      return false;
    }
    if (this.subscription) {
      return this.subscription;
    }

    const subscription = await this.registration.pushManager.getSubscription();
    if (subscription) {
      this.subscription = subscription;
      return this.subscription;
    }

    this.subscription = await this.makeNewSubscription();
    await this.registerSubscription(this.subscription);

    return this.subscription;
  }

  async unsubscribe() {
    if (this.subscription) {
      await this.subscription.unsubscribe();
    }
  }

  async askNotification() {
    if (!('Notification' in window)) {
      return false;
    }
    if (Notification.permission === 'granted') {
      return true;
    }
    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }

    return false;
  }
}
